import type { CSSProperties } from 'react';

import classNames from 'classnames';

import * as styles from './List.css';
import type { BulletedListElementProps, NumberedListElementProps } from './List.types';

export function BulletedListElement(props: BulletedListElementProps) {
  const { element, children, attributes, className } = props;
  const { width, maxWidth, customAttributes } = element.attrs || {};

  return (
    <ul
      {...customAttributes}
      className={classNames(className, styles.listElement, customAttributes?.className)}
      style={
        {
          '--width': width,
          '--max-width': maxWidth,
        } as CSSProperties
      }
      {...attributes}
    >
      {children}
    </ul>
  );
}

export function NumberedListElement(props: NumberedListElementProps) {
  const { element, children, attributes, className } = props;
  const { width, maxWidth, customAttributes } = element.attrs || {};

  return (
    <ol
      {...customAttributes}
      className={classNames(className, styles.listElement, customAttributes?.className)}
      style={
        {
          '--width': width,
          '--max-width': maxWidth,
        } as CSSProperties
      }
      {...attributes}
    >
      {children}
    </ol>
  );
}
